import {
	useOpenTabMode as useSharedOpenTabMode,
	useOpenTabNotifier,
} from '@supply-mover-2-0/web-ui';
import { useNavigate } from 'react-router-dom';
import { PORTAL_OPEN_TAB_APP, portalOpenTabOwner } from '../lib/portalOpenTab';
import { canShowTabNotifications, isPortalBrowserPushOn } from '../lib/portalPush';
import {
	portalNotificationsSource,
	resolvePortalNotificationPath,
} from '../services/portalNotificationService';
import { usePortalAuthStore } from '../stores/portalAuthStore';

/** Whether open-tab mode is on for this customer, kept current across tabs. */
export function useOpenTabMode(publicUserId: number | null): boolean {
	return useSharedOpenTabMode(
		PORTAL_OPEN_TAB_APP,
		portalOpenTabOwner(publicUserId),
	);
}

/**
 * PD-17322 — the storefront's browser notifications from the open tab, for
 * a browser that allows notifications but cannot receive Web Push (Brave
 * ships with its push service off). Mounted once in PortalLayout for a
 * signed-in customer; renders nothing. The work (one leader tab reading the
 * newest bell rows on every tick of the shared unread poll, no replay,
 * one tab per notification, real push wins) is useOpenTabNotifier in
 * libs/web-ui, shared with the CRM.
 */
export function PortalTabNotifier(): null {
	const navigate = useNavigate();
	const publicUserId = usePortalAuthStore((s) => s.profile?.id ?? null);
	useOpenTabNotifier({
		app: PORTAL_OPEN_TAB_APP,
		owner: portalOpenTabOwner(publicUserId),
		source: portalNotificationsSource,
		resolvePath: resolvePortalNotificationPath,
		canShow: canShowTabNotifications,
		isPushSubscribed: isPortalBrowserPushOn,
		isSessionActive: () => usePortalAuthStore.getState().token != null,
		onNavigate: (path) => {
			void navigate(path);
		},
	});
	return null;
}
